import {
  FormDisciplinaViewComponent
} from "../../../../pareristica/fascicoloFormShared/form-disciplina/view/form-disciplina-view.component";
import {
  FormAltrerisoluzionilavoroComponent
} from "../../../../pareristica/fascicoloFormShared/form-altrerisoluzionilavoro/form-altrerisoluzionilavoro.component";
import {
  FormAccessoagliattiComponent
} from "../../../../pareristica/fascicoloFormShared/form-accessoagliatti/form-accessoagliatti.component";
import {FascicoloDisciplina} from "../../../../pareristica/fascicoloFormShared/models/disciplina/fascicolo-disciplina";
import {
  FormDisciplinaComponent
} from "../../../../pareristica/fascicoloFormShared/form-disciplina/form-disciplina.component";
import {
  FormAccessoagliattiViewComponent
} from "../../../../pareristica/fascicoloFormShared/form-accessoagliatti/view/form-accessoagliatti-view.component";
import {
  FormOpposaiserviziispettiviComponent
} from "../../../../pareristica/fascicoloFormShared/form-opposaiserviziispettivi/form-opposaiserviziispettivi.component";
import {
  FascicoloAccessoagliatti
} from "../../../../pareristica/fascicoloFormShared/models/accessoagliatti/fascicolo-accessoagliatti";
import {
  FormOpposaiserviziispettiviViewComponent
} from "../../../../pareristica/fascicoloFormShared/form-opposaiserviziispettivi/view/form-opposaiserviziispettivi-view.component";
import {
  FascicoloAltrerisoluzionilavoro
} from "../../../../pareristica/fascicoloFormShared/models/altrerisoluzionilavoro/fascicolo-altrerisoluzionilavoro";
import {
  FascicoloOpposaiserviziispettivi
} from "../../../../pareristica/fascicoloFormShared/models/opposaiserviziispettivi/fascicolo-opposaiserviziispettivi";
import {
  FormAltrerisoluzionilavoroViewComponent
} from "../../../../pareristica/fascicoloFormShared/form-altrerisoluzionilavoro/view/form-altrerisoluzionilavoro-view.component";
import {
  FormParereViewComponent
} from "../../../../pareristica/fascicoloFormShared/form-parere/view/form-parere-view.component";
import {FormParereComponent} from "../../../../pareristica/fascicoloFormShared/form-parere/form-parere.component";
import {FascicoloParere} from "../../../../pareristica/fascicoloFormShared/models/parere/fascicolo-parere";
import { FascicoloConsulenza } from "src/app/pareristica/fascicoloFormShared/models/consulenza/fascicolo-consulenza";
import { FascicoloGestioneAmministrativa } from "src/app/pareristica/fascicoloFormShared/models/gestioneamministrativa/fascicolo-gestione-amministrativa";
import { FascicoloGenerico } from "src/app/pareristica/fascicoloFormShared/models/generico/fascicolo-generico";
import { FormConsulenzaViewComponent } from "src/app/pareristica/fascicoloFormShared/form-consulenza/view/form-consulenza-view.component";
import { FormConsulenzaComponent } from "src/app/pareristica/fascicoloFormShared/form-consulenza/form-consulenza.component";
import { FormGestioneAmministrativaViewComponent } from "src/app/pareristica/fascicoloFormShared/form-gestione-amministrativa/view/form-gestione-amministrativa-view.component";
import { FormGestioneAmministrativaComponent } from "src/app/pareristica/fascicoloFormShared/form-gestione-amministrativa/form-gestione-amministrativa.component";
import { FormGenericoViewComponent } from "src/app/pareristica/fascicoloFormShared/form-generico/view/form-generico-view.component";
import { FormGenericoComponent } from "src/app/pareristica/fascicoloFormShared/form-generico/form-generico.component";


export function getComponentFromFormTenantPareristica(idFormTenant, view = false) {

  switch (idFormTenant) {
    case 'ParPar_PRD': {
      return view ? FormParereViewComponent : FormParereComponent;
    }
    case 'ParDis_PRD': {
      return view ? FormDisciplinaViewComponent : FormDisciplinaComponent;
    }
    case 'ParAlt_PRD': {
      return view ? FormAltrerisoluzionilavoroViewComponent : FormAltrerisoluzionilavoroComponent;
    }
    case 'ParAcc_PRD': {
      return view ? FormAccessoagliattiViewComponent : FormAccessoagliattiComponent;
    }
    case 'ParOsi_PRD': {
      return view ? FormOpposaiserviziispettiviViewComponent : FormOpposaiserviziispettiviComponent;
    }
    case 'ParCons_PRD': {
      return view ? FormConsulenzaViewComponent : FormConsulenzaComponent;

    }
    case 'ParGes_PRD': {
      return view ? FormGestioneAmministrativaViewComponent : FormGestioneAmministrativaComponent;

    }
    case 'ParGen_PRD': {
      return view ? FormGenericoViewComponent : FormGenericoComponent;

    }
  }
}

export function getFascicoloPareristica(genericFascicolo): any {
  switch (genericFascicolo) {
    case 'parere': {
      return new FascicoloParere();
    }
    case 'disciplina': {
      return new FascicoloDisciplina();
    }
    case 'altrerisoluzionilavoro': {
      return new FascicoloAltrerisoluzionilavoro();
    }
    case 'accessoagliatti': {
      return new FascicoloAccessoagliatti();
    }
    case 'opposaiserviziispettivi': {
      return new FascicoloOpposaiserviziispettivi();
    }
    case 'consulenza': {
      return  new FascicoloConsulenza();
    }
    case 'gestioneamministrativa': {
      return new FascicoloGestioneAmministrativa();
    }
    case 'genericoconsulenza': {
      return new FascicoloGenerico();
    }
  }
}
